import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Button from 'shared/button';
import ListingSelect from './listing_select';
import Modal from 'components/modal';
import { buildNewDeal } from 'bundles/project/components/deals_tab/creation/helpers';

export default function DealCreationModal({ listings, path, show, onHide, onNewDeal }) {
  const [listing, setListing] = useState();

  React.useEffect(() => {
    if (show) {
      setListing(null);
    }
  }, [show]);

  async function handleOk() {
    if (listing) {
      const deal = await buildNewDeal(path, listing);
      onNewDeal(deal, listing);
    }
  }

  return (
    <Modal
      backdrop="static"
      show={show}
      onHide={onHide}
    >
      <Modal.Header closeButton>
        New Deal
      </Modal.Header>

      <Modal.Body>
        <ListingSelect
          listings={listings}
          value={listing}
          onChange={setListing}
        />
      </Modal.Body>

      <Modal.Footer>
        <Button.Cancel onClick={onHide} />
        <Button.Primary disabled={!listing} onClick={handleOk}>
          Ok
        </Button.Primary>
      </Modal.Footer>
    </Modal>
  );
}

DealCreationModal.propTypes = {
  listings: PropTypes.array,
  path: PropTypes.string.isRequired,
  show: PropTypes.bool,
  onHide: PropTypes.func.isRequired,
  onNewDeal: PropTypes.func.isRequired,
};
